import React from 'react'
import { FormControl, TextField } from '@mui/material'

export const DateFilter = (props) => {
  const { value, setValue, label, name } = props

  const handleDateOnChange = (e) => {
    setValue(e.target.value)
  }

  return (
    <FormControl>
      <TextField
        label={label}
        type='date'
        name={name}
        value={value}
        margin='none'
        placeholder='yyyy-mm-dd'
        onChange={handleDateOnChange}
      />
    </FormControl>
  )
}
